import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/main',
    name: 'Main',
    component: () => import(/* webpackChunkName: "main" */ '@/views/Main.vue'),
    children: [
      {
        path: 'profile',
        name: 'Profile',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/main/Profile.vue')
      },
      {
        path: 'user',
        name: 'User',
        component: () => import(/* webpackChunkName: "user" */ '@/views/main/User.vue')
      },
      {
        path: 'role',
        name: 'Role',
        component: () => import(/* webpackChunkName: "role" */ '@/views/main/Role.vue')
      },
      {
        path: 'appInfo',
        name: 'AppInfo',
        component: () => import(/* webpackChunkName: "appInfo" */ '@/views/main/AppInfo.vue')
      },
      {
        path: 'themeInfo',
        name: 'ThemeInfo',
        component: () => import(/* webpackChunkName: "appInfo" */ '@/views/main/ThemeInfo.vue')
      },
      {
        path: 'urlInfo',
        name: 'UrlInfo',
        component: () => import(/* webpackChunkName: "role" */ '@/views/main/UrlInfo.vue')
      },
      {
        path: 'appList',
        name: 'appList',
        component: () => import(/* webpackChunkName: "role" */ '@/views/main/appManage/list.vue')
      },
      {
        path: 'appList/add',
        name: 'appAdd',
        component: () => import(/* webpackChunkName: "role" */ '@/views/main/appManage/add.vue')
      },
      {
        path: 'appList/detail',
        name: 'appDetail',
        component: () => import(/* webpackChunkName: "role" */ '@/views/main/appManage/detail.vue')
      },
      {
        path: 'basePlat',
        name: 'basePlat',
        component: () => import(/* webpackChunkName: "role" */ '@/views/main/basePlat.vue')
      },
      {
        path: 'payManage/list',
        name: 'payManage',
        component: () => import(/* webpackChunkName: "role" */ '@/views/main/payMange/list.vue')
      },
      {
        path: 'companyManage/list',
        name: 'companyManage',
        component: () => import(/* webpackChunkName: "role" */ '@/views/main/companyManage/list.vue')
      },
      {
        path: 'componentList',
        name: 'componentList',
        component: () => import(/* webpackChunkName: "role" */ '@/views/main/componentManage'),
        children: []
      },
      {
        path: 'componentList/add',
        name: 'componentAdd',
        component: () => import(/* webpackChunkName: "role" */ '@/views/main/componentManage/listPage/add.vue')
      },
      {
        path: 'componentList/detail',
        name: 'componentDetail',
        component: () => import(/* webpackChunkName: "role" */ '@/views/main/componentManage/listPage/detail.vue')
      },
      {
        path: 'componentType',
        name: 'componentType',
        component: () => import(/* webpackChunkName: "role" */ '@/views/main/componentManage/type.vue')
      },
      {
        path: 'menuList',
        name: 'menuList',
        component: () => import(/* webpackChunkName: "role" */ '@/views/main/menuManage')
      },
      {
        path: 'menuList/add',
        name: 'menuAdd',
        component: () => import(/* webpackChunkName: "role" */ '@/views/main/menuManage/listPage/add.vue')
      },
      {
        path: 'menuList/detail',
        name: 'menuDetail',
        component: () => import(/* webpackChunkName: "role" */ '@/views/main/menuManage/listPage/detail.vue')
      },
      {
        path: 'schemeList',
        name: 'schemeList',
        component: () => import(/* webpackChunkName: "role" */ '@/views/main/schemeManage')
      },
      {
        path: 'schemeList/add',
        name: 'schemeAdd',
        component: () => import(/* webpackChunkName: "role" */ '@/views/main/schemeManage/listPage/add.vue')
      },
      {
        path: 'schemeList/detail',
        name: 'schemeDetail',
        component: () => import(/* webpackChunkName: "role" */ '@/views/main/schemeManage/listPage/detail.vue')
      },
      {
        path: 'applicationReview',
        name: 'applicationReview',
        component: () => import(/* webpackChunkName: "applicationReview" */ '@/views/main/applicationReview/list.vue')
      },
      {
        path: 'partsManage',
        name: 'partsManage',
        component: () => import(/* webpackChunkName: "partsManage" */ '@/views/main/partsManage')
      },
      {
        path: 'unifiedIdentityAuth',
        name: 'unifiedIdentityAuth',
        component: () => import(/* webpackChunkName: "partsManage" */ '@/views/main/unifiedIdentityAuth/index.vue')
      }
    ]
  },
  {
    path: '/appVersion/:cusId',
    name: 'EditAppVersion',
    props: true,
    component: () => import(/* webpackChunkName: "appVersion" */ '@/views/pages/EditAppVersion.vue')
  },
  {
    path: '/beforeLogin',
    name: 'BeforeLogin',
    component: () => import(/* webpackChunkName: "beforeLogin" */ '@/views/BeforeLogin.vue')
  },
  {
    path: '*',
    name: 'Error404',
    component: () => import(/* webpackChunkName: "error404" */ '@/views/Error404.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
